import { CircularProgress as Circular, type CircularProgressProps } from '@mui/material'

export type ICircularProgressProps = CircularProgressProps & {
  variant?: 'determinate' | 'indeterminate'
  size?: number
  customColor?: string
  thickness?: number
}

export const CircularProgress = ({
  variant = 'determinate',
  size = 12,
  customColor,
  thickness = 6,
  ...props
}: ICircularProgressProps) => {
  return (
    <Circular
      variant={variant}
      size={size}
      thickness={thickness}
      sx={{ color: customColor || 'inherit' }}
      {...props}
    />
  )
}
